/* eslint-disable prefer-rest-params */
import React, { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchPrivacyPolicyCMSAPI } from '../../../api/cms.api'

export default function PrivacyPolicyComponent() {
  const [language, setLanguage] = useState(localStorage.getItem('language') ?? 'en')

  // Fetch CMS content with language dependency
  const { data, isLoading, error, refetch } = useQuery(
    ['fetchPrivacyPolicyCMSData', language],
    async () => {
      const response = await fetchPrivacyPolicyCMSAPI(language)
      return response.data
    },
    { keepPreviousData: true },
  )

  // Listen for localStorage changes (both from storage event & same tab)
  useEffect(() => {
    const handleStorageChange = () => {
      const newLang = localStorage.getItem('language') ?? 'en'
      if (newLang !== language) {
        setLanguage(newLang)
        refetch() // Manually trigger API call
      }
    }

    // Detect local changes
    const originalSetItem = localStorage.setItem
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments)
      if (key === 'language') handleStorageChange()
    }

    // Detect changes across tabs
    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      localStorage.setItem = originalSetItem // Restore original function
    }
  }, [language, refetch])

  if (isLoading) return <p>Loading...</p>
  if (error) return <p>Error fetching data</p>

  return <div dangerouslySetInnerHTML={{ __html: data || 'No content available.' }} />
}
